module.exports = __webpack_public_path__ + "img/proyecto_3.e48202fb.webp";